module.exports = __webpack_public_path__ + "img/bookmark.217ad858.svg";